module.exports = "/wp-content/themes/onnit/script/cart/dist/onnitJointOilUpsellBg-836a8b8d.jpg";